import React from 'react';

const CartItemOptions = ({ options, variantId }) => {
  return (
    <div className="flex gap-0.5">
      {!!options.length &&
        options.map((option, index, arr) => (
          <>
            <div
              className="body-3"
              key={`${variantId}-${option.name}-${index}`}
              aria-label={`${option.name}: ${option.value}`}
            >
              {option.value}
            </div>
            {index < arr.length - 1 && (
              <span
                className="body-3"
                key={index}
              >
                |
              </span>
            )}
          </>
        ))}
    </div>
  );
};

export default CartItemOptions;
